import React, { useEffect, useState } from 'react'
import {
  DEFAULT_DAYS_WARNING_MIN,
  DEFAULT_DAYS_WARNING_MAX,
  COPYRIGHT_YEAR,
} from 'constants/index'
import { Button, Card } from 'react-bootstrap'
import store from 'state/store'
import { setSettingsSAC } from 'state/sagas/settings/settings.actions'
import { useSettings } from 'state/settings'
import { useL10n } from 'modules/Localization'
import packageJson from '../../../package.json'
import SettingsCardNumber from './SettingsCardNumber'
import SupplementalSettingsCard from './SupplementalSettingsCard'
import { getSupplementalSettingsCardData } from './Settings.helpers'

const Settings = () => {
  const { settings: previousSettings } = useSettings()
  const [practiceDelayValue, setPracticeDelayValue] = useState(
    previousSettings.practiceDelay
  )

  const setPracticeDelay = (e: any) => {
    const {
      target: { value },
    } = e
    const normalizedValue = +value
    if (
      normalizedValue >= DEFAULT_DAYS_WARNING_MIN &&
      normalizedValue <= DEFAULT_DAYS_WARNING_MAX
    ) {
      setPracticeDelayValue(normalizedValue)
    }
  }

  const [warningRatioValue, setWarningRatioValue] = useState(
    previousSettings.warningRatio
  )

  useEffect(() => {
    setPracticeDelayValue(previousSettings.practiceDelay)
    setWarningRatioValue(previousSettings.warningRatio)
  }, [previousSettings])

  const setWarningRatio = (e: any) => {
    const {
      target: { value },
    } = e
    const normalizedValue = Math.round(+value * 10) / 10
    if (normalizedValue >= 0 && normalizedValue <= 1) {
      setWarningRatioValue(normalizedValue)
    }
  }

  const { t } = useL10n()

  const supplementalSettingsCardData = getSupplementalSettingsCardData()

  return (
    <div style={{ margin: '10px' }} id="Settings-page">
      <h2>{t('pages.settings.title')}</h2>
      <SettingsCardNumber
        onChange={setPracticeDelay}
        value={practiceDelayValue}
        subtitle={t('pages.settings.practiceDelay.subtitle')}
        text={t('pages.settings.practiceDelay.text')}
      />
      <SettingsCardNumber
        onChange={setWarningRatio}
        value={warningRatioValue}
        subtitle={t('pages.settings.warningRatio.subtitle')}
        text={t('pages.settings.warningRatio.text')}
        step={0.1}
      />
      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        <Button
          style={{ margin: '5px' }}
          variant="success"
          onClick={() =>
            store.dispatch(
              setSettingsSAC({
                practiceDelay: +practiceDelayValue,
                warningRatio: +warningRatioValue,
              })
            )
          }
        >
          {t('pages.settings.saveSettingsChanges')}
        </Button>

        <Button
          style={{ margin: '5px' }}
          variant="warning"
          onClick={() => {
            setPracticeDelayValue(previousSettings.practiceDelay)
            setWarningRatioValue(previousSettings.warningRatio)
          }}
        >
          {t('pages.settings.clearSettingsChanges')}
        </Button>
      </div>

      <hr style={{ borderWidth: '3px' }} />

      {/* @ts-ignore */}
      {supplementalSettingsCardData.map(SupplementalSettingsCard)}

      <Card.Body style={{ textAlign: 'center', paddingTop: '20px' }}>
        {`${t('brand.copyright', {
          year: COPYRIGHT_YEAR,
        })} - ${t('brand.versionNumber', {
          versionNumber: packageJson.version,
        })}`}
      </Card.Body>
    </div>
  )
}

export default Settings
